<app-message-list
  [guest]="guestItem"
  [messages]="guestItem.emailMessages"
  [emptyTableType]="tableType"
  [hasMove]="false"
></app-message-list>
